import { Capacitor } from '@capacitor/core';

import { getVersionApp } from './get-version-app';

interface CapgoCurrentBundle {
  id: string;
  version: string;
}

interface CapgoCurrentResult {
  bundle: CapgoCurrentBundle;
  native: string;
}

const resolveDisplayVersion = (
  current: CapgoCurrentResult,
  fallback: string
): string => {
  if (current.bundle.id === 'builtin') {
    return current.native || fallback;
  }

  return current.bundle.version || fallback;
};

export async function getAppDisplayVersion(): Promise<string> {
  const fallback = getVersionApp() ?? '';

  if (!Capacitor.isNativePlatform()) {
    return fallback;
  }

  try {
    const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
    const current = (await CapacitorUpdater.current()) as CapgoCurrentResult;

    return resolveDisplayVersion(current, fallback);
  } catch {
    return fallback;
  }
}
